import { API } from '../../utils/api';

export function userGetSingleVoucher(data) {
  return (dispatch) => {
    return API.post('/gift-voucher/single', data).then((res) => {
      return res.data;
    });
  };
}
